import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GameSortOptions } from '../Games/types';

interface applicationState {
	gameSortOrder: GameSortOptions;
}

const initialState: applicationState = {
	gameSortOrder: GameSortOptions.Alphabetical
};

const applicationSlice = createSlice({
	name: 'applicationSlice',
	initialState,
	reducers: {
		setGameSorting(state, action: PayloadAction<GameSortOptions>) {
			return {
				...state,
				gameSortOrder: action.payload
			};
		}
	}
});

export const { setGameSorting } = applicationSlice.actions;

export default applicationSlice;
